import React, { useCallback, useEffect } from 'react'

import {
  ExclamationCircleOutlined,
} from '@ant-design/icons';

import { Select } from 'antd';

import GSTC from 'gantt-schedule-timeline-calendar'
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'gantt-schedule-timeline-calendar/dist/style.css'
import dayjs from 'dayjs';

// var advancedFormat = require('dayjs/plugin/advancedFormat')
// dayjs.extend(advancedFormat)

const { Option } = Select;
// import './App.css'
const GSTCID = GSTC.api.GSTCID;
let gstc, state, data, date_from, date_to, min_date, max_date, show_is_overdue = '1', show_type = '1'
// helper functions

const color_blue = "#3498DB"
const color_yellow = "#F1C40F"
const color_gray = "#7F8C8D"
const color_green = "#27AE60"
const color_orange = "#FFA500"

const icon_overdue = `<span role="img" aria-label="exclamation-circle" class="anticon anticon-exclamation-circle"><svg viewBox="64 64 896 896" focusable="false" data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path></svg></span>`

const customPeriodMonth = [
  {
    zoomTo: 100, // we want to display this format for all zoom levels until 100
    period: 'month',
    // periodIncrement: 0,
    // style:{
    //   'justify-content': 'center',
    // },
    main: show_type == '1'?true:false,
    format({ timeStart, timeEnd }) {
      return timeStart.format('MMMM YYYY'); // full list of formats: https://day.js.org/docs/en/display/format
    },
  },
];

const customPeriodYear = [
  {
    zoomTo: 100, // we want to display this format for all zoom levels until 100
    period: 'year',
    // periodIncrement: 0,
    // style:{
    //   'justify-content': 'center',
    // },
    main: show_type == '1'?false:true,
    format({ timeStart, timeEnd }) {
      return timeStart.format('YYYY'); // full list of formats: https://day.js.org/docs/en/display/format
    },
  },
];

const customPeriodWeek = [
  {
    zoomTo: 100, // we want to display this format for all zoom levels until 100
    period: 'week',
    // periodIncrement: 0,
    // style:{
    //   'justify-content': 'center',
    // },
    main: false,
    format({ timeStart, timeEnd }) {
      var weekOfYear = require('dayjs/plugin/weekOfYear')
      dayjs.extend(weekOfYear)

      return `W: ${dayjs(timeStart).week()}`; // full list of formats: https://day.js.org/docs/en/display/format
    },
  },
];

function initializeGSTC(element) {
  /**
   * @type { import("gantt-schedule-timeline-calendar").Config }
   */

  // const config = {
  //   licenseKey:
  //     '====BEGIN LICENSE KEY====\nFcVm5sULPlVkiPdPBLxMujVgWenD+SGdr8KnY3oq5nhWIpFPNF+vJUa5zIuT9lsUrgGFKeMK7NVMJglq1UwhnIBnWHzA+s6fFkKZxOmOC4SByGUVZAYiBCa4ZXYcz54RqRsZlIPnOONqZtSHsdGoM/Uz27r69trIS3cu9k2Q21ql46/cIOyBKDHoglfD9Ob6cXHVDib3s4oc2wM1YsI9YJx6JoMq3Lq5wTCQey0/dZgyIRJYJYreDiZo6zs31DuNmz90qPg1INNkY8C3c2enGiFpPgvr6FQ1qME3vCF1Zl5YqH6oIEeGM5bqlhxRJF4z2xs9b0Qjpt6nYdHxfpdL1w==||U2FsdGVkX19sWkQTLF+ZIbKhFOuGdgQFpfJJqCqRLg4iojvp4AjHGaTzzNKJUBvnQVYmjfhjl5BNmQQJUa6SGBWM3CBFXZuYldd94M5t+Xg=\nmt3TT2HijTsPrNkoMcKqyUgCN7IZjxL/uOnXwYB4aZoxC6w3/IuEh6uwBC5SDW0gi6KxpMrUZL01pg3XCyOfOr9T0+dFTZ7VM4IPGIEVCGBdKq+OAQGukkhUM2rKkSzdS7UCJTeyhcIYF4svOZmZnLGsJN7ZD42ottL/NaSyPwDk2M5bHFyl5RBE3RAXuo4nh7CoRIe4GLVnbiz++GAhcuK+kOzp3RoMDDfPTUQkznjE5PP5SBsoJ3hNPQdi87LrRo+L4REN8e1hA3yVhZLgFPHSSK6bPQz1JM/MUHu7j/TPyAed2B7u1PMXmBbfyFD2lwx4/3UXH/15ysAR6IvS8w==\n====END LICENSE KEY====',
  //   plugins: [],

  //   list: {
  //     columns: {
  //       data: GSTC.api.fromArray(columnsFromDB),
  //     },
  //     rows: GSTC.api.fromArray(rowsFromDB),
  //   },
  //   chart: {
  //     items: GSTC.api.fromArray(itemsFromDB),
  //     calendarLevels: [customPeriod],
  //     time: {
  //       zoom: 24,
  //       from: GSTC.api.date(date_from).valueOf(),
  //       to: GSTC.api.date(date_to).endOf('year').valueOf(),
  //     },
  //   },
  //   actions: {
  //     // 'chart-timeline-items-row-item': [itemTippy],
  //   },
  // }
  // console.log(JSON.stringify(rowsFromDB))
  // console.log(rowsFromDB)

  const config = {
    licenseKey:
      '====BEGIN LICENSE KEY====\nFcVm5sULPlVkiPdPBLxMujVgWenD+SGdr8KnY3oq5nhWIpFPNF+vJUa5zIuT9lsUrgGFKeMK7NVMJglq1UwhnIBnWHzA+s6fFkKZxOmOC4SByGUVZAYiBCa4ZXYcz54RqRsZlIPnOONqZtSHsdGoM/Uz27r69trIS3cu9k2Q21ql46/cIOyBKDHoglfD9Ob6cXHVDib3s4oc2wM1YsI9YJx6JoMq3Lq5wTCQey0/dZgyIRJYJYreDiZo6zs31DuNmz90qPg1INNkY8C3c2enGiFpPgvr6FQ1qME3vCF1Zl5YqH6oIEeGM5bqlhxRJF4z2xs9b0Qjpt6nYdHxfpdL1w==||U2FsdGVkX19sWkQTLF+ZIbKhFOuGdgQFpfJJqCqRLg4iojvp4AjHGaTzzNKJUBvnQVYmjfhjl5BNmQQJUa6SGBWM3CBFXZuYldd94M5t+Xg=\nmt3TT2HijTsPrNkoMcKqyUgCN7IZjxL/uOnXwYB4aZoxC6w3/IuEh6uwBC5SDW0gi6KxpMrUZL01pg3XCyOfOr9T0+dFTZ7VM4IPGIEVCGBdKq+OAQGukkhUM2rKkSzdS7UCJTeyhcIYF4svOZmZnLGsJN7ZD42ottL/NaSyPwDk2M5bHFyl5RBE3RAXuo4nh7CoRIe4GLVnbiz++GAhcuK+kOzp3RoMDDfPTUQkznjE5PP5SBsoJ3hNPQdi87LrRo+L4REN8e1hA3yVhZLgFPHSSK6bPQz1JM/MUHu7j/TPyAed2B7u1PMXmBbfyFD2lwx4/3UXH/15ysAR6IvS8w==\n====END LICENSE KEY====',
    list: {
      rows: rowsFromDB,

      columns: {
        data: {
          'incident': {
            id: 'incident',
            data: 'incident',
            width: 200,
            header: {
              content: 'ชื่อรายงาน'
            }
          },
          'taskName': {
            id: 'taskName',
            isHTML: true,
            data: 'taskName',
            expander: true,
            width: 200,
            header: {
              content: 'ชื่อแผนงาน'
            }
          },
          'assignee': {
            id: 'assignee',
            data: 'assignee',
            width: 200,
            header: {
              content: 'ผู้รับมอบหมาย'
            }
          },
        }
      }

    },
    chart: {
      calendarLevels: show_type == '1'?[customPeriodYear,customPeriodMonth]:[customPeriodMonth, customPeriodWeek],
      time: {
        zoom: 23,
        from: GSTC.api.date(min_date).valueOf(),
        to: GSTC.api.date(max_date).valueOf(),
      },
      items: itemsFromDB
    },
    actions: {
      'chart-timeline-items-row-item': [itemTippy],
    },
  };

  state = GSTC.api.stateFromConfig(config)

  gstc = GSTC({
    element,
    state,
  })
}

let rowsFromDB = []
let itemsFromDB = []
// let columnsFromDB = [
//   // {
//   //   id: "id",
//   //   label: "ID",
//   //   data: ({ row }) => GSTC.api.sourceID(row.id), // show original id (not internal GSTCID)
//   //   // sortable: ({ row }) => Number(GSTC.api.sourceID(row.id)), // sort by id converted to number
//   //   width: 80,
//   //   header: {
//   //     content: "ID",
//   //   },
//   // },
//   {
//     id: "incident",
//     data: "incident",
//     sortable: "incident",
//     isHTML: false,
//     width: 230,
//     header: {
//       content: "Incident",
//     },
//   },
//   {
//     id: "taskName",
//     data: "taskName",
//     sortable: "taskName",
//     isHTML: false,
//     width: 230,
//     // expander: true,
//     header: {
//       content: "Task Name",
//     },
//   },
//   {
//     id: "riskOwner",
//     data: "riskOwner",
//     sortable: "riskOwner",
//     isHTML: false,
//     width: 230,
//     header: {
//       content: "Risk Owner",
//     },
//   },
// ]
let rowsQuarterData = {}
let itemQuarterData = {}

function setTippyContent(element, data) {
  if (!gstc) return;
  if (element._tippy == undefined) {
    tippy(element, { trigger: 'mouseenter click' });
    if (!element._tippy) return;

    const item = data?.item?.item_data
    element._tippy.setContent(`
      ${item?.task_name},
      ${item?.task_assignee?.employee?.employee_name_th},
      ${item?.task_due_date},
      ${item?.task_priority?.value_list_name},
      ${item?.task_status?.value_list_name},
      ${item?.task_result == null ? '' : item?.task_result}
    `);
  }

  if ((!data || !data.item) && element._tippy) return element._tippy.destroy();
  const itemData = gstc.api.getItemData(data.item.id);
  if (!itemData) return element._tippy.destroy();
  if (itemData.detached && element._tippy) return element._tippy.destroy();
  if (!itemData.detached && !element._tippy) tippy(element, { trigger: 'mouseenter click' });
  if (!element._tippy) return;

  const item = data?.item?.item_data
  element._tippy.setContent(`
    ${item?.task_name},
    ${item?.task_assignee?.employee?.employee_name_th},
    ${item?.task_due_date},
    ${item?.task_priority?.value_list_name},
    ${item?.task_status?.value_list_name},
    ${item?.task_result == null ? '' : item?.task_result}
  `);
}

function itemTippy(element, data) {
  setTippyContent(element, data);
  return {
    update(element, data) {
      if (element._tippy) element._tippy.destroy();
      setTippyContent(element, data);
    },
    destroy(element, data) {
      if (element._tippy) element._tippy.destroy();
    },
  };
}

const setQuarterData = () => {
  rowsQuarterData = {}
  itemQuarterData = {}
  let mapper = {}
  let count_key = 1
  let count_key_task = 1
  let count_incident = 0
  let color_item = 0

  data.map((item, key) => {
    if (item.report_task.length == 0) {
      // rowsQuarterData[count_key.toString()] = {
      //   id: count_key.toString(),
      //   incident: item.incident_topic,
      //   taskName : item.task_name,
      //   riskOwner: item.risk_owner,
      //   style: { background:'#ffffff'},
      // }

      // count_key++
    } else {
      item.report_task.map((item_report_task, key_report_task) => {

        if (item_report_task?.parent_task_id != null) return;

        let taskName = ''
        if (show_is_overdue == '1') {

        } else if (show_is_overdue == '2') {
          if (item_report_task.is_overdue == false) {
            return;
          }
        } else {
          if (item_report_task.is_overdue == true) {
            return;
          }
        }
        if (item_report_task.is_overdue == true) {
          taskName = `<div>${icon_overdue} ${item_report_task.task_name}</div>`
        } else {
          taskName = `<div>${item_report_task.task_name}</div>`
        }
        mapper[item_report_task.report_task_id.toString()] = count_key
        rowsQuarterData[count_key] = {
          id: count_key.toString(),
          incident: item.incident_topic,
          taskName: taskName,
          riskOwner: item.risk_owner,
          parentId: mapper[item_report_task.parent_task_id],
          assignee: item?.assignee?.employee?.employee_name_th,
          expanded: true,
          style: { background: '#ffffff' },
        }

        let color
        if (item_report_task.task_status.value_list_code == 'CRT') {
          color = color_blue
        } else if (item_report_task.task_status.value_list_code == 'INP') {
          color = color_yellow
        } else if (item_report_task.task_status.value_list_code == 'HLD') {
          color = color_gray
        } else if (item_report_task.task_status.value_list_code == 'DON') {
          color = color_green
        } else {
          color = color_orange
        }

        if (min_date == null || min_date == undefined) {
          min_date = item_report_task.created_at
        } else {
          if (min_date > item_report_task.created_at) {
            min_date = item_report_task.created_at
          }
        }

        if (max_date == null || max_date == undefined) {
          max_date = item_report_task.task_due_date
        } else {
          if (max_date < item_report_task.task_due_date) {
            max_date = item_report_task.task_due_date
          }
        }

        itemQuarterData[count_key_task.toString()] = {
          id: count_key_task.toString(),
          rowId: count_key.toString(),
          taskName: item_report_task.task_name,
          item_data: item_report_task,
          // label: item_report_task?.task_priority?.value_list_name,
          style: { background: color },
          time: {
            start: GSTC.api.date(item_report_task.created_at).startOf("day").valueOf(),
            end: GSTC.api.date(item_report_task.task_due_date).endOf("day").valueOf(),
          }
        }
        count_key_task++
        count_key++

        item_report_task?.child_task.map((item_report_child_task, key_report_task) => {


          let taskName = ''
          if (show_is_overdue == '1') {

          } else if (show_is_overdue == '2') {
            if (item_report_child_task.is_overdue == false) {
              return;
            }
          } else {
            if (item_report_child_task.is_overdue == true) {
              return;
            }
          }
          if (item_report_child_task.is_overdue == true) {
            taskName = `<div>${icon_overdue} ${item_report_child_task.task_name}</div>`
          } else {
            taskName = `<div>${item_report_child_task.task_name}</div>`
          }
          mapper[item_report_child_task.report_task_id.toString()] = count_key
          rowsQuarterData[count_key] = {
            id: count_key.toString(),
            incident: item.incident_topic,
            taskName: taskName,
            riskOwner: item.risk_owner,
            parentId: mapper[item_report_child_task.parent_task_id],
            assignee: item?.assignee?.employee?.employee_name_th,
            expanded: true,
            style: { background: '#ffffff' },
          }

          let color
          if (item_report_child_task.task_status.value_list_code == 'CRT') {
            color = color_blue
          } else if (item_report_child_task.task_status.value_list_code == 'INP') {
            color = color_yellow
          } else if (item_report_child_task.task_status.value_list_code == 'HLD') {
            color = color_gray
          } else if (item_report_child_task.task_status.value_list_code == 'DON') {
            color = color_green
          } else {
            color = color_orange
          }

          if (min_date == null || min_date == undefined) {
            min_date = item_report_child_task.created_at
          } else {
            if (min_date > item_report_child_task.created_at) {
              min_date = item_report_child_task.created_at
            }
          }

          if (max_date == null || max_date == undefined) {
            max_date = item_report_child_task.task_due_date
          } else {
            if (max_date < item_report_child_task.task_due_date) {
              max_date = item_report_child_task.task_due_date
            }
          }

          itemQuarterData[count_key_task.toString()] = {
            id: count_key_task.toString(),
            rowId: count_key.toString(),
            taskName: item_report_child_task.task_name,
            item_data: item_report_child_task,
            // label: item_report_child_task?.task_priority?.value_list_name,
            style: { background: color },
            time: {
              start: GSTC.api.date(item_report_child_task.created_at).startOf("day").valueOf(),
              end: GSTC.api.date(item_report_child_task.task_due_date).endOf("day").valueOf(),
            }
          }
          count_key_task++
          count_key++
        })

      })
    }
  });
}

function App({ dataSource, filters, hideContent }) {

  data = dataSource
  date_from = filters.date_from
  date_to = filters.date_to

  const callback = useCallback((element) => {

    if (element) initializeGSTC(element);
  }, [])

  useEffect(() => {
    if (data) {
      const element = document.getElementsByClassName("gstc-wrapper")[0]
      if (element) {
        setQuarterData()
        rowsFromDB = rowsQuarterData
        itemsFromDB = itemQuarterData
        initializeGSTC(element)
      }
    }
  }, [data])

  return (
    <div className="App" style={{ display: hideContent == true ? 'None' : '' }}>
      <div className="toolbox">
      </div>
      <div style={{ textAlign: 'end', paddingBottom: '10px' }}>
        <Select
          id='select_show_type'
          defaultValue="1"
          style={{ width: 120, textAlign: 'left', paddingRight: '5px' }}
          onChange={(value) => {
            show_type = value
            if (data) {
              const element = document.getElementsByClassName("gstc-wrapper")[0]
              if (element) {
                setQuarterData()
                rowsFromDB = rowsQuarterData
                itemsFromDB = itemQuarterData
                initializeGSTC(element)
              }
            }
          }}
        >
          <Option value='1'>Monthly</Option>
          <Option value="2">Weekly</Option>
        </Select>
        <Select
          id='select_is_overdue_show'
          defaultValue="1"
          style={{ width: 120, textAlign: 'left' }}
          onChange={(value) => {
            show_is_overdue = value
            if (data) {
              const element = document.getElementsByClassName("gstc-wrapper")[0]
              if (element) {
                setQuarterData()
                rowsFromDB = rowsQuarterData
                itemsFromDB = itemQuarterData
                initializeGSTC(element)
              }
            }
          }}
        >
          <Option value='1'>แสดงทั้งหมด</Option>
          <Option value="2">เกินกำหนด</Option>
          <Option value="3">ตามกำหนด</Option>
        </Select>
      </div>
      {data ? <div className="gstc-wrapper" ref={callback}></div> : null}

    </div>
  );
}

export default App;